import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ProcessType } from '@models/process-type.model';
import { PagedResponse } from '@models/response.model';

import { TableConfig } from '@app/shared/util/table-config.utils';
import { AppUtils } from '@app/shared/util/app.utils';

import { environment } from 'environments/environment';
import { RiskClass } from "@app/strain/config/risk-classes/models/risk-class.model";
import { map } from "rxjs/operators";

/**
 * Service class for handling CRUD operations on {@link ProcessType} objects.
 */
@Injectable()
export class ProcessTypeService {

    static readonly PROCESS_TYPES_API_GET_PATH = `${environment.baseURL}/api/processTypes`;
    static readonly API_CONFIG_RISK_CLASSES_PATH = `${environment.baseURL}/api/strain/riskClasses`;

    constructor(private http: HttpClient) { }


    getAllRiskClasses(config: TableConfig = null) {
        const params = AppUtils.buildPageableParams(config);
        return this.http.get<PagedResponse<RiskClass>>(`${ProcessTypeService.API_CONFIG_RISK_CLASSES_PATH}`, {params});
    }

    getAllProcessTypes(tableConfig: TableConfig = null) {
        const params = AppUtils.buildPageableParams(tableConfig);
        return this.http.get<PagedResponse<ProcessType>>(ProcessTypeService.PROCESS_TYPES_API_GET_PATH, {params: params})
            .pipe(map(this.mapProcessTypes));
    }

    mapProcessTypes = res => {
        return {
            processTypes: res.items.map(processType => new ProcessType(processType)),
            count: res.total
        };
    };

    createProcessType(processType) {
        return this.http.post<ProcessType>(ProcessTypeService.PROCESS_TYPES_API_GET_PATH, processType);
    }

    updateProcessType(processType) {
        return this.http.put<ProcessType>(`${ProcessTypeService.PROCESS_TYPES_API_GET_PATH}/${processType.id}`, processType);
    }

    deleteProcessType(processType) {
        return this.http.delete<ProcessType>(`${ProcessTypeService.PROCESS_TYPES_API_GET_PATH}/${processType.id}`);
    }

}
